<template>
<header  class="clearfix site-header" id="header_view">

  <div class="logo">
    <router-link  to="/"><a href="/"><img src="../assets/img/logo.png" alt="ロゴ画像" class="logoImg"></a></router-link>
  </div>
  <div class="navigation">
    <nav class="gnav">
      <ul class="navigation gnav__menu">
        <li class="gnav__menu__item">
          <a href="#" @click="clickSmoothScroll('about')">
            <div class="gnav__menu__item">
              futurelaboとは
            </div>
          </a>
        </li>
        <li class="gnav__menu__item">
          <a href="#" @click="clickSmoothScroll('service')">
            <div class="gnav__menu__item">
          サービス
            </div>
          </a>
        </li>
        <li>
          <a href="#" @click="clickSmoothScroll('client')">
            <div class="gnav__menu__item">
              主要取引先
            </div>
          </a>
        </li>
        <li>
          <a href="#" @click="clickSmoothScroll('career')">
            <div class="gnav__menu__item">
              採用情報
            </div>
          </a>
        </li>
        <li class="gnav__menu__item">
          <a href="#" @click="clickSmoothScroll('company')">
            <div>会社概要
            </div>
          </a>
        </li>
        <!--
        <li>
          <a href="#" @click="clickSmoothScroll('news')">
            <div class="gnav__menu__item">ニュース
            </div>
          </a>
        </li>
        -->
        <li>
          <router-link to="/contact">
            <div class="gnav__menu__item color2_button">お問い合わせ</div>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
  <div id="nav-drawer">
    <input id="nav-input" type="checkbox" class="nav-unshown">
    <label id="nav-open" for="nav-input">
    <span></span>
    <span></span>
    <span></span>
    <!-- <span class="menuTxt">MENU</span> -->
    </label>
    <label class="nav-unshown" id="nav-close" for="nav-input"></label>
    <div id="nav-content">
      <div class="navigation_sp">
        <ul class="navigation_sp">
          <li @click="spSidebarClick"><a href="#" @click="clickSmoothScroll('about')">futurelaboとは</a></li>
          <li @click="spSidebarClick"><a href="#" @click="clickSmoothScroll('service')">サービス</a></li>
          <li @click="spSidebarClick"><a href="#" @click="clickSmoothScroll('client')">主要取引先</a></li>
          <li @click="spSidebarClick"><a href="#" @click="clickSmoothScroll('career')">採用情報</a></li>
          <li @click="spSidebarClick"><a href="#" @click="clickSmoothScroll('company')">会社情報</a></li>
          <li @click="spSidebarClick"><router-link to="/contact">お問い合わせ</router-link></li>
        </ul>
      </div>
    </div>
  </div>
</header>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      msg: 'header'
    }
  },
  methods: {
    spSidebarClick () {
      document.querySelector('#nav-input').checked = false
    },
    clickSmoothScroll (target) {
      event.preventDefault()
      if (document.querySelector('#' + target)) {
        this.$SmoothScroll(
          document.querySelector('#' + target),
          400,
          null,
          null,
          'y'
        )
      } else {
        location.href = '/#' + target
      }
    }
  }
}

</script>

<style>
  * {
    margin:0;
    padding:0;
    color: #585858;
    font-family:'メイリオ',Meiryo,YuGothic,'Yu Gothic','Avenir','Helvetica Neue','Helvetica','Arial','Hiragino Sans','ヒラギノ角ゴシック','ＭＳ Ｐゴシック','MS PGothic';
  }
  h1{
    font-size:3.2em;
  }
  h2{
    font-size: 1.4em;
  }
  h3{
    font-size: 1.2em;
  }
  h4{
    font-size: 1.6em;
  }
  h5{
    font-size: 1.4em;
  }
  p{
    font-size: 0.8em;
    color: #4b4b4b;
  }
  ul,li{
    list-style: none;
  }
  ul.navigation .color2_button:hover a{
    color: #1f30aa;
  }
  .gnav__menu{
    /*display: flex;*/
    /*flex-wrap: wrap;*/
  }
  .site-header{
    background: #fff;
    display: flex;
    position: fixed;
    width: 100%;
    padding: 1% 2%;
    z-index: 999;
  }
  .gnav__menu__item{
    margin-left: 30px;
  }
  .navigation{
    /*vertical-align: baseline;*/
    /*margin-top: 10px;*/
    /*margin-left: 60px;*/
    align-items: center;
    display: flex;
    margin-right: 20px;
    /*flex-wrap: wrap;*/
  }
  ul.navigation .color2_button a{
    color: #ffffff;
  }
  ul.navigation .color2_button:hover a{
    color: #1f30aa;
  }
  .color2_button{
    color: #fff;
    background-color: #1f30aa;
    border: 2px solid #1f30aa;
    display: inline-block;
    width: 200px;
    height: 36px;
    text-align: center;
    text-decoration: none;
    line-height: 34px;
    outline: none;
    margin-top: -20px;
  }
  .color2_button::before,
  .color2_button::after{
    position: absolute;
    display: block;
    content: '';
  }
  .color2_button,
  .color2_button::before,
  .color2_button::after{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all .3s;
    transition: all .3s;
  }
  .color2_button:hover{
    background-color: #fff;
    border-color: #1f30aa;
    color: #1f30aa;
  }
  ul.navigation li a{
    color:#1f30aa;
    font-size: 0.9em;
  }
  .top_titile span{
    font-size: 2.2em;
    font-weight: bold;
  }
  .top_titile h1{
    font-weight: 900;
  }
  .top_titile h1,
  .top_titile span{
    color: #fff;
    background-color: #1f30aa;
    padding-right: 30px;
  }

  ul.navigation li.contact_btn a{
    color: #fff;
  }
  #nav-drawer{
    display: none;
  }
  .logo {
    display: flex;
    flex: 1 auto;
  }
  @media screen and (max-width:867px) {
    .logoImg {
      width: 157px;
      height: 60px;
      margin-left: 20px;
    }
    h2, h3 {
      color: #1f30aa;
    }
    ul.navigation li {
      display: inline-block;
      padding: 0 20px;
      color: #1f30aa;
    }

    ul.navigation {
      padding: 30px;
    }

    ul.navigation li a {
      color: #1f30aa;
    }

    .clearfix:after {
      content: "";
      clear: both;
      display: block;
    }

    .navigation {
      display: none;
    }

    ul.navigation_sp {
      color: #2d2d2d;
      padding-left: 10%;
      padding-top: 5%;
    }

    ul.navigation_sp li {
      padding: 10% 3%;
    }

    ul.navigation_sp li a {
      font-size: 1.0em;
      color: #fff;
    }
header{
  display: block;
  height: auto;
}
#nav-content li a, .gnav li a{
  text-decoration: none;
}

    #header-logo-menu,
    #nav-drawer {
      display: flex;
      align-items: center;
      margin-right: 30px;
    }

    .header-logo-menu {
      float: right;
      margin-right: 4%;
    }

    .nav-unshown {
      display: none;
    }

    #nav-open {
      display: inline-block;
      width: 30px;
      height: 22px;
      vertical-align: middle;
    }

    #nav-open,
    #nav-open span {
      display: inline-block;
      transition: all .4s;
      box-sizing: border-box;
    }

    #nav-open {
      position: relative;
      width: 50px;
      height: 34px;
    }

    #nav-open span {
      position: absolute;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: #1f30aa;
      border-radius: 4px;
    }

    #nav-open span:nth-of-type(1) {
      top: 0;
    }

    #nav-open span:nth-of-type(2) {
      top: 15px;
    }

    #nav-open span:nth-of-type(3) {
      bottom: 0;
    }

    #nav-open.active span:nth-of-type(1) {
      -webkit-transform: translateY(20px) rotate(-315deg);
      transform: translateY(20px) rotate(-315deg);
    }

    #nav-open.active span:nth-of-type(2) {
      opacity: 0;
    }

    #nav-open.active span:nth-of-type(3) {
      -webkit-transform: translateY(-20px) rotate(315deg);
      transform: translateY(-20px) rotate(315deg);
    }

    #nav-close {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: black;
      opacity: 0;
      transition: .3s ease-in-out;
    }

    #nav-content {
      overflow: auto;
      position: fixed;
      top: 0;
      left: 0;
      width: 70%;
      max-width: 330px;
      height: 100%;
      background: #1f30aa;
      transition: .3s ease-in-out;
      -webkit-transform: translateX(-105%);
      transform: translateX(-105%);
    }

    #nav-input:checked ~ #nav-close {
      display: block;
      opacity: .5;
    }

    #nav-input:checked ~ #nav-content {
      -webkit-transform: translateX(0%);
      transform: translateX(0%);
      box-shadow: 6px 0 25px rgba(0, 0, 0, .15);
    }

    .header-logo-menu {
      display: flex;
      display: -moz-flex;
      display: -o-flex;
      display: -webkit-flex;
      display: -ms-flex;
      flex-direction: row;
      -moz-flex-direction: row;
      -o-flex-direction: row;
      -webkit-flex-direction: row;
      -ms-flex-direction: row;
    }
    .site-header{
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue